import { Formik, FormikHelpers } from "formik";
import { useFormSubmit } from "melco-shared-logic";

import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { DisplayGenerateLicenseForm } from "./DisplayGenerateLicenseForm";
import { useQueryClient } from "react-query";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";

import { useGenerateLicense } from "../../../hooks/licenses/useGenerateLicense";
import dayjs from "dayjs";

type GenerateLicenseFormValueType = {
  product_code: string;
  serial_number: string;
  subscription_code: string;
  referral_code: string;
  version_id: string;
  subscription_start_date?: Date | null;
};

type GenerateLicenseFormProps = {
  referenceDrawer: DrawerType;
  onCloseDrawer: (closeDrawer: boolean) => void;
  onGenerateLicenseCallBackFn: (obj: any) => any;
};

export const GenerateLicenseForm: React.FC<GenerateLicenseFormProps> = ({
  referenceDrawer,
  onCloseDrawer,
  onGenerateLicenseCallBackFn,
}) => {
  const queryClient = useQueryClient();
  const queryKey = "licensing";
  const GenerateLicense = useGenerateLicense();
  const todayDateTime = dayjs().startOf("day").toDate();
  const onSubmit = async (
    values: GenerateLicenseFormValueType,
    formikHelpers: FormikHelpers<GenerateLicenseFormValueType>
  ) => {
    await onGenerateSerialNumber(values, formikHelpers, {
      isManuallyResettingForm: true,
    });
  };

  const generateLicenseFormToInitialValues = (
    formvalues: GenerateLicenseFormValueType
  ) => {
    const {
      version_id,
      product_code,
      subscription_code,
      referral_code,
      serial_number,
      subscription_start_date,
    } = formvalues;

    const initialValues: GenerateLicenseFormValueType = {
      product_code: product_code ?? "",
      referral_code: subscription_code ?? "",
      subscription_code: referral_code ?? "",
      serial_number: serial_number ?? "",
      version_id: version_id ?? "",
      subscription_start_date: subscription_start_date ?? null,
    };

    return initialValues;
  };

  const initialValues: GenerateLicenseFormValueType = {
    product_code: "",
    referral_code: "",
    subscription_code: "",
    serial_number: "1",
    version_id: "",
    subscription_start_date: todayDateTime,
  };

  const handleGenerateLicense = async (
    values: GenerateLicenseFormValueType,
    formikHelpers: FormikHelpers<GenerateLicenseFormValueType>,
    options: {}
  ) => {
    //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)
    let newEntity: any = await GenerateLicense({
      product_code: values.product_code,
      subscription_code: values.subscription_code,
      referral_code: values.referral_code,
      number_of_licenses:
        values.serial_number && values.serial_number != ""
          ? parseInt(values.serial_number)
          : 0,
      version_id: values.version_id,
      subscription_start_date: values?.subscription_start_date
        ? values?.subscription_start_date
        : undefined,
    });
    //console.log("newEntity",newEntity)
    console.log(newEntity);
    formikHelpers.resetForm({
      values: generateLicenseFormToInitialValues(
        newEntity ?? {
          product_code: "",
          referral_code: "",
          subscription_code: "",
          serial_number: "1",
          version_id: "",
          subscription_start_date: null,
        }
      ),
    });
    //queryClient.setQueryData(queryKey, newEntity);
    onCloseDrawer(false);
    onGenerateLicenseCallBackFn(newEntity);
  };

  const formSubmitToGenerateLicense = () => {
    return [
      async (
        values: GenerateLicenseFormValueType,
        formikHelpers: FormikHelpers<GenerateLicenseFormValueType>
      ) => {
        return handleGenerateLicense(values, formikHelpers, {});
      },
      {
        //  translationPrefix: "licenses.basic.detail.Generate",
        // translationOptions: {
        //   batchnumber: 1,
        //        },
        translationPrefix: ["licenses.basic.detail", "generate"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onGenerateSerialNumber = useFormSubmit(
    ...formSubmitToGenerateLicense()
  );

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize
      >
        <DirtyFormPrompt>
          <DisplayGenerateLicenseForm
            referenceDrawer={referenceDrawer}

          // onCloseDrawer={onCloseDrawer}
          />
        </DirtyFormPrompt>
      </Formik>
    </>
  );
};
